import { useCallback } from 'react';
import { useQueryClient, useMutation } from 'react-query';
import addFlatMeter from '../requests/addFlatMeter';
import { getQueryKeys } from '../queries/queryKeys';
import { useAddFlatMeterAttachments } from '../requests/addFlatMeterAttachments';
import changeFlatMeter from '../requests/changeFlatMeter';

const useFlatMeterMutations = () => {
  const { addAttachments } = useAddFlatMeterAttachments();
  const queryClient = useQueryClient();

  const invalidateMeters = useCallback(
    (addressId) =>
      queryClient.invalidateQueries(getQueryKeys.flatMeters(addressId)),
    [queryClient]
  );

  const changeMeter = useMutation(
    ({ values, meterId }) => {
      const { attachments, ...restValues } = values;
      return changeFlatMeter(meterId, restValues);
    },
    {
      onSuccess: async (data, { values, meterId }) => {
        if (data && data !== 'Error') {
          if (values.attachments?.length) {
            await addAttachments({ meterId, files: values.attachments });
          }
          invalidateMeters(values.addressId);
        }
      },
    }
  );

  const addMeter = useMutation(
    ({ values }) => {
      const { attachments, ...restValues } = values;
      return addFlatMeter(restValues);
    },
    {
      onSuccess: async (data, { values }) => {
        if (data?.id) {
          if (values.attachments?.length) {
            await addAttachments({
              meterId: data.id,
              files: values.attachments,
            });
          }
          invalidateMeters(values.addressId);
        }
      },
    }
  );

  return {
    add: addMeter.mutateAsync,
    edit: changeMeter.mutateAsync,
    isLoading: addMeter.isLoading || changeMeter.isLoading,
  };
};

export default useFlatMeterMutations;
